import type { FC } from "react"
import { useCallback } from "react"
import { Link, useLocation } from "react-router-dom"
import { useConfigModel } from "@/models"
import { Tabs } from "antd"
import { headerTabs } from "@/constants/constant"
import { getMenuKeyByPath } from "@/util/commonUtils"
import { getAllParentIds, isInvalid } from "@/util/util"
import "./index.scss"
// ==============================================
import SvgIcon from "@/components/SvgIcon"
// ==============================================
const { TabPane } = Tabs
// ==============================================
const SecondaryTabs: FC<any> = () => {
  const { pathname } = useLocation()
  const [, sandTableId, brandId, cityId, path] = pathname?.split("/") || []
  const { currentConfig } = useConfigModel()
  const modules = currentConfig?.modules || []
  const visible = isInvalid(currentConfig?.visible) ? false : currentConfig?.visible
  const menuKey = getMenuKeyByPath(path)
  const ids = getAllParentIds(modules, menuKey, "moduleType")
  const parentKey = ids?.[0]
  const list =
    menuKey === parentKey ? [] : modules.find((m) => m.moduleType === parentKey)?.children || []
  const result = list.map((v) => {
    const item = headerTabs.find((tab) => tab.value === v.moduleType)
    return {
      ...item,
      label: v.moduleName,
      unlocked: v.unlocked,
    }
  })

  // 获取dom
  const getDomElement = useCallback((icon, label) => {
    return (
      <>
        <SvgIcon
          src={icon || require("@/assets/page-indicator/analysis.svg").default}
          title={label}
        />
        <div>{label}</div>
      </>
    )
  }, [])

  return (
    <div className="second-order-menus">
      <Tabs className="secondary-tabs" tabPosition="left" type="card" activeKey={menuKey}>
        {result.map((tab) => {
          if (!visible && !tab.unlocked) return null
          return (
            <TabPane
              key={tab.value}
              tab={
                <div className="img-box">
                  {tab.unlocked ? (
                    <Link to={`/${sandTableId}/${brandId}/${cityId}/${tab.path}`}>
                      {getDomElement(tab.icon, tab.label)}
                    </Link>
                  ) : (
                    <div className="lock">{getDomElement(tab.icon, tab.label)}</div>
                  )}
                </div>
              }
            >
              {tab.label}
            </TabPane>
          )
        })}
      </Tabs>
    </div>
  )
}

export default SecondaryTabs
